import React from 'react';
import './loader.scss';

interface ILoader {
  activeLoader?:boolean
  label?: string,
  children?:any
}

const Loader : React.FC<ILoader> = ({activeLoader, label,children}) => {

    return(
      <>
      <div
        className={`box-loader  ${activeLoader?"active":""}`}
        role="status"
        aria-live="polite"
        aria-label={label || 'Cargando...'}
      >
        <div className="loader-spinner" data-testid='divLoader' aria-hidden="true"></div>
        <span className='label-loader'>{label}</span>
      </div>
      {children}
      </>
    )
}

export default Loader;